import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { AdminTeams } from "./AdminTeams";
import { AdminUsers } from "./AdminUsers";

// AdminPage is all the built-in admin account sees. It reaches the app itself only
// through "View as".
export function AdminPage() {
    const [tab, setTab] = useState<"users" | "teams">("users");

    return (
        <>
            <Typography variant="h5">Admin</Typography>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                <Tabs value={tab} onChange={(_, value) => setTab(value)}>
                    <Tab value="users" label="Users" />
                    <Tab value="teams" label="Teams" />
                </Tabs>
            </Box>

            {tab === "users" ? <AdminUsers /> : <AdminTeams />}
        </>
    );
}
